import React from 'react';

import { RoutingFilterResponse } from '../../serverApi/requests/RoutingFilterTypes';

export type ConflictError = Readonly<{
  errorCode: string;
  message: string;
  routingRuleId?: string;
  invalidFields?: Record<string, string[]>;
}>;

export type UnsavedFilter = Readonly<{
  filter: RoutingFilterResponse;
  isNew: boolean;
  conflictErrors: ReadonlyArray<ConflictError>;
  conflictingFilterIds: ReadonlySet<string>;
}>;

export type RoutingFiltersConflictContextValue = Readonly<{
  unsavedFilter: UnsavedFilter | null;
  clearUnsavedFilter: () => void;
  // Whether the other filters that conflict with the unsaved one should be
  // highlighted. Starts false so only the unsaved row is highlighted; flips to
  // true once the user opens the conflict badge on the unsaved row.
  conflictsHighlighted: boolean;
  showConflictingRoutingFilters: () => void;
}>;

export const RoutingFiltersConflictContext = React.createContext<RoutingFiltersConflictContextValue | null>(null);

export function useRoutingFiltersConflict(): RoutingFiltersConflictContextValue {
  const context = React.useContext(RoutingFiltersConflictContext);
  if (!context) {
    throw new Error('useRoutingFiltersConflict must be used within a RoutingFiltersConflictContext.Provider');
  }
  return context;
}
